import { render, staticRenderFns } from "./ShopMemberForgotPassword.vue?vue&type=template&id=1e90478e&"
import script from "./ShopMemberForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ShopMemberForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports